import React from 'react';
import swal from 'sweetalert';
import { spmfcloudFunctionUrl, getAttachment } from '../../actions/salesforces';
import { fetchQueryData } from '../../utils/sf-request';

export async function getApplicationDetail(id) {
    const personFields = [
        'Company__c', 'Contact_Number__c', 'Current_Level__c', 'Email_Address__c',
        'Employment_Status__c', 'Full_Name__c', 'Gender__c', 'Home_Phone__c', 'ID_Number__c', 'ID_Type__c',
        'Marital_Status__c', 'Mobile_Phone__c', 'Monthly_Gross_Income__c', 'Nationality__c', 'Occupation__c', 'Office_Number__c', 'Other_Marital_Status__c', 'Other_Nationality__c',
        'Other_Race__c', 'Other_Religion__c', 'PDPA_Consent__c', 'Race__c', 'Relationship_to_Applicant__c',
        'Relationship_to_Applicant_Other__c', 'Relationship_to_Beneficiary__c', 'Relationship_to_Beneficiary_Other__c', 'Religion__c', 'Remarks__c', 'Stream__c', 'Date_of_Birth__c',
        'Main_Applicant__c', 'RecordType.Name', 'Applying_to__c', 'Current_School__c', 'No_of_Receipts_Approved__c', 'Id',
    ];

    const applicationFields = [
        'Alcoholism__c', 'Applicant__c', 'Application_Status__c', 'Application_Type__c', 'Block__c',
        'City__c', 'Chronic_Illness__c', 'Country__c', 'Cultural_or_personal_belief__c',
        'Date_of_Application__c', 'Disability__c', 'Flat_Type__c', 'Gambling_Addiction__c',
        'Home_Ownership__c', 'Low_Education__c', 'Other_Source_of_Income__c',
        'Other_Source_of_Income_Amount__c', 'Postal__c', 'Reason_s_for_Single_No_income_earner__c',
        'Related_Account__c', 'Social_Visit_Pass__c', 'Source_of_Application__c', 'Street__c',
        'Temporarily_unfit_for_work__c', 'Unit_Number__c', 'Media_Coverage_consent__c',
    ];

    // Retrieve both beneficiaries and household members
    const query = `SELECT ${personFields.join(', ')}, ${applicationFields.map(field => `Application__r.${field}`).join(', ')} FROM Person__c WHERE Application__r.Id='${id}'`;
    // ORDER BY Application__r.Name DESC`;

    const config = {
        mode: 'cors',
        body: JSON.stringify({ query }),
        cache: 'no-cache',
        method: 'POST',
        headers: {
            'hash-token': this.props.user.siteToken.hash,
            'Content-Type': 'application/json',
        },
    };

    const json = await fetchQueryData(query, this.props.siteToken.hash, this.props.user.key);

    // Determine the main applicant
    const mainApplicant = json.records.filter(record => record.Main_Applicant__c)[0];

    const deleteRecordType = (record) => {
        // Delete RecordType.Name to avoid error on submission
        const clone = Object.assign({}, record);
        delete clone.RecordType;
        return { attachment: [], data: clone };
    };

    // Determine the beneficiaries
    const beneficiary = json.records.filter(record => (!record.Main_Applicant__c) && record.RecordType.Name === 'Beneficiary')
        .map(deleteRecordType);

    // Determine the household members (main applicant is a household member as well)
    const householdMembers = json.records.filter(record => /* (!record.Main_Applicant__c) && */ record.RecordType.Name === 'Household Member')
        .map(deleteRecordType);

    json.data = {
        person: mainApplicant,
        application: json.records[0].Application__r,
        householdMembers,
        beneficiary,
    };

    delete json.records;

    // Retrieve attachments
    // 1. Beneficiaries
    const beneId = beneficiary.map(bene => `ParentId = '${bene.data.Id}'`).join(' OR ');
    // 2. Household Members (incl. Main Applicant)
    const householdMemberId = householdMembers.map(member => `ParentId = '${member.data.Id}'`).join(' OR ');
    const attachmentQuery = `SELECT ParentId, Name, Body, ContentType, Description FROM Attachment WHERE ${beneId} ${householdMemberId.length ? 'OR' : ''} ${householdMemberId}`;
    config.body = JSON.stringify({ query: attachmentQuery });

    const attachmentJson = await fetchQueryData(attachmentQuery, this.props.user.siteToken.hash, this.props.user.key);

    for (let a = 0; a < attachmentJson.records.length; a++) {
        // Body is not a base64-encoded string, but a URL. We need to retrieve it directly from SF with that URL
        const base64 = await getAttachment(attachmentJson.records[a].Body, this.props.salesforce.token);
        attachmentJson.records[a].Body = base64;
    }

    // Get and set beneficiaries' attachments
    const beneAttachment = attachmentJson.records.filter(attach => attach.Description === 'bene_nric_fin_file');

    json.data.beneficiary.forEach((bene, index) => {
        if (beneAttachment[index]) {
            if (beneAttachment[index].ParentId === bene.data.Id) {
                bene.attachment = beneAttachment[index];
            }
        }
    });

    // Get and set household members' attachments
    const householdAttachmentTypes = ['nric_fin_file', 'cpmf_statement', 'payslip'];
    const householdAttachment = attachmentJson.records.filter(attach => householdAttachmentTypes.includes(attach.Description));

    json.data.householdMembers.forEach((member, index) => {
        if (householdAttachment[index]) {
            if (householdAttachment[index].ParentId === member.data.Id) {
                switch (householdAttachment[index].Description) {
                    case 'nric_fin_file':
                        member.attachment.file1 = householdAttachment[index];
                        delete member.attachment.file1.Id;
                        break;
                    case 'cpmf_statement':
                        member.attachment.file2 = householdAttachment[index];
                        delete member.attachment.file2.Id;
                        break;
                    case 'payslip':
                        member.attachment.file3 = householdAttachment[index];
                        delete member.attachment.file3.Id;
                        break;
                    default:
                }
            }
        }
    });

    return json;
}

export async function saveApplication() {
    // Preparing the request body from component's state
    const reqBody = await this.applicationFormFunc(true);
    reqBody.application.Application_Status__c = 'Draft';
    reqBody.partnerId = this.props.user.loggedInUser.AccountId;

    try {
        this.setState({ isLoading: true });
        // 1. Save minimum data to SF
        /* const salesforceToken = this.props.salesforce.token;
        const sfResult = await saveObject('Application__c', reqBody.application, salesforceToken); */
        const draftId = this.props.match.params.registrationId || this.state.draftId;

        const json = await fetch(`${spmfcloudFunctionUrl}/db/applications/${draftId}`, {
            mode: 'cors',
            body: JSON.stringify(reqBody),
            cache: 'no-cache',
            method: draftId ? 'PATCH' : 'POST',
            headers: {
                'hash-token': this.props.user.siteToken.hash,
                'Content-Type': 'application/json',
            },
        }).then(async (response) => {
            const json_ = await response.json();
            if (!response.ok) throw new Error(json_.message);
            return json_;
        });

        const newState = { isLoading: false };
        if (json.data.draftId) {
            newState.draftId = json.data.draftId;
        }
        this.setState(newState);
        swal({
            icon: 'success',
            title: 'Success',
            text: 'The application has been successfully saved but not submitted yet',
        });
    } catch (err) {
        this.setState({ isLoading: false });
        swal({
            html: true,
            icon: 'error',
            title: 'Error',
            text: err.message,
        });
    }
}

export async function deleteApplication() {
    const response = await fetch(`${spmfcloudFunctionUrl}/db/applications/${this.props.match.params.registrationId || this.state.draftId}`, {
        mode: 'cors',
        cache: 'no-cache',
        method: 'DELETE',
        headers: {
            'hash-token': this.props.user.siteToken.hash,
        },
    });

    const json = await response.json();
    if (!response.ok) throw new Error(json.message);
    return json;
}

export default null;



//////////////////
// WEBPACK FOOTER
// ./src/components/Registration/actions.js
// module id = 1051
// module chunks = 0